/*
 * Generic NuORDER Error type. Should not be used outside of this file.
 *
 */

function NuError(code, message, args) {
    this.name = 'NuError';
    this.code = code;
    this.arguments = args;
    this.message = message || 'An error occurred';
    this.stack = (new Error()).stack;
}

NuError.prototype = Object.create(Error.prototype);
NuError.prototype.constructor = NuError;

/*
 * NuORDER Error to be used with 304/not modified
 *
 */
function NotModifiedError(message, args) {
    this.constructor.call(this, 304, message, args);
    this.name = "NotModifiedError";
}

NotModifiedError.prototype = Object.create(NuError.prototype);
NotModifiedError.prototype.constructor = NuError;

/*
 * NuORDER Error to be used with 404/not found
 *
 */
function NotFoundError(message, args) {
    this.constructor.call(this, 404, message, args);
    this.name = "NotFoundError";
}

NotFoundError.prototype = Object.create(NuError.prototype);
NotFoundError.prototype.constructor = NuError;

/*
 * NuORDER Error to be used with 404/not found
 *
 */
function UnknownCommandError(message, args) {
    this.constructor.call(this, 400, message || "Unknown or invalid command", args);
    this.name = "UnknownCommandError";
}

UnknownCommandError.prototype = Object.create(NuError.prototype);
UnknownCommandError.prototype.constructor = NuError;

/*
 * Error to be used with 400/bad arguments
 *
 */
function BadArgumentsError(message, args) {
    this.constructor.call(this, 400, message || "Invalid arguments", args);
    this.name = "BadArgumentsError";
}

BadArgumentsError.prototype = Object.create(NuError.prototype);
BadArgumentsError.prototype.constructor = NuError;

/*
 * Error to be used with 409/conflict
 *
 */
function ConflictError(message, args) {
    this.constructor.call(this, 409, message || "Conflict", args);
    this.name = "ConflictError";
}

ConflictError.prototype = Object.create(NuError.prototype);
ConflictError.prototype.constructor = NuError;

/*
 * Error to be used with 401/unauthorized
 *
 */
function NotAuthenticatedError(message, args) {
    this.constructor.call(this, 401, message || "Not authenticated", args);
    this.name = "NotAuthenticatedError";
}

NotAuthenticatedError.prototype = Object.create(NuError.prototype);
NotAuthenticatedError.prototype.constructor = NuError;

/*
 * Error to be used with 403/forbidden
 *
 */
function ForbiddenError(message, args) {
    this.constructor.call(this, 403, message || "Forbidden", args);
    this.name = "ForbiddenError";
}

ForbiddenError.prototype = Object.create(NuError.prototype);
ForbiddenError.prototype.constructor = NuError;

/*
 * Error to be used with 403/rule violation such as an inventory error
 *
 */
function RuleViolationError(message, args) {
    this.constructor.call(this, 403, message || "A restriction has been violated", args);
    this.name = "RuleViolationError";
}

RuleViolationError.prototype = Object.create(NuError.prototype);
RuleViolationError.prototype.constructor = NuError;

/*
 * Error to be used with a 411/length required error
 *
 */
function LengthRequiredError(message, args) {
    this.constructor.call(this, 411, message || "A length is required", args);
    this.name = "LengthRequiredError";
}

LengthRequiredError.prototype = Object.create(NuError.prototype);
LengthRequiredError.prototype.constructor = NuError;


/*
 * Error to be used with 423/locked resource
 *
 */
function LockedError(message, args) {
    this.constructor.call(this, 423, message || "Locked", args);
    this.name = "LockedError";
}

LockedError.prototype = Object.create(NuError.prototype);
LockedError.prototype.constructor = NuError;

/*
 * Error to be used with 500/general error
 *
 */
function GeneralError(message, args) {
    this.constructor.call(this, 500, message || "An error occurred", args);
    this.name = "GeneralError";
}

GeneralError.prototype = Object.create(NuError.prototype);
GeneralError.prototype.constructor = NuError;

/*
 * Error to be used with 500/general error
 *
 */
function DatabaseError(message, args) {
    this.constructor.call(this, 500, message || "An error occurred", args);
    this.name = "DatabaseError";
}

DatabaseError.prototype = Object.create(NuError.prototype);
DatabaseError.prototype.constructor = NuError;

/*
 * Error to be used with 502/bad gateway error
 *
 */
function BadGatewayError(message, args) {
    this.constructor.call(this, 502, message || "Bad Gateway", args);
    this.name = "BadGatewayError";
}

BadGatewayError.prototype = Object.create(NuError.prototype);
BadGatewayError.prototype.constructor = NuError;

/*
 * Error to be used with 503/service not abailable error
 *
 */
function ServiceNotAvailableError(message, args) {
    this.constructor.call(this, 503, message || "Service not available", args);
    this.name = "ServiceNotAvailableError";
}

ServiceNotAvailableError.prototype = Object.create(NuError.prototype);
ServiceNotAvailableError.prototype.constructor = NuError;

/*
 * Error to be used with 504/gateway timeout error
 *
 */
function GatewayTimeoutError(message, args) {
    this.constructor.call(this, 504, message || "Gateway Timeout", args);
    this.name = "GatewayTimeoutError";
}

GatewayTimeoutError.prototype = Object.create(NuError.prototype);
GatewayTimeoutError.prototype.constructor = NuError;

module.exports = {
    DatabaseError: DatabaseError, // 500
    GeneralError: GeneralError, // 500
    NotModifiedError: NotModifiedError, // 304
    UnknownCommandError: UnknownCommandError, // 400
    BadArgumentsError: BadArgumentsError, // 400
    NotAuthenticatedError: NotAuthenticatedError, // 401
    ForbiddenError: ForbiddenError, // 403
    RuleViolationError: RuleViolationError, // 403
    NotFoundError: NotFoundError, // 404
    ConflictError: ConflictError,  // 419
    LockedError: LockedError, // 423
    LengthRequiredError: LengthRequiredError, // 411
    BadGatewayError: BadGatewayError, // 502
    ServiceNotAvailableError: ServiceNotAvailableError, // 503
    GatewayTimeoutError: GatewayTimeoutError, // 504
};
